export default __webpack_public_path__ + "static/media/carePackage.96ec71f2.svg";